<section class="hero" aria-label="Főoldal">
  @if (profile(); as p) {
    <div class="hero__container">
      <div class="hero__content">
        <p class="hero__eyebrow">{{ p.hero.eyebrow }}</p>
        <h1 class="hero__title">
          {{ p.hero.titleLead }}
          <span class="hero__title-accent">{{ p.hero.titleAccent }}<br>{{ p.hero.titleAccentContinued }}</span>
          {{ p.hero.titleTail }}
        </h1>
        <p class="hero__subtitle">{{ p.hero.subtitle }}</p>
        <div class="hero__actions">
          <app-cta-button
            [label]="p.hero.primaryCta.label"
            variant="primary"
            [fullWidth]="true"
            [fragment]="p.hero.primaryCta.fragment"
            [icon]="p.hero.primaryCta.icon ?? ''"
          />
          <app-cta-button
            [label]="p.hero.secondaryCta.label"
            variant="secondary"
            [inverse]="true"
            [fullWidth]="true"
            [fragment]="p.hero.secondaryCta.fragment"
          />
        </div>
      </div>

      <div class="hero__visual" aria-hidden="true">
        <div class="hero__mockups">
          <div class="mockup mockup--desktop">
            <div class="mockup__bar">
              <span class="mockup__dot"></span>
              <span class="mockup__dot"></span>
              <span class="mockup__dot"></span>
            </div>
            <div class="mockup__content">
              <div class="mockup__header-strip"></div>
              <div class="mockup__body">
                <div class="mockup__block mockup__block--wide"></div>
                <div class="mockup__block mockup__block--medium"></div>
                <div class="mockup__row">
                  <div class="mockup__block mockup__block--card"></div>
                  <div class="mockup__block mockup__block--card"></div>
                  <div class="mockup__block mockup__block--card"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="mockup mockup--mobile">
            <div class="mockup__notch"></div>
            <div class="mockup__content">
              <div class="mockup__header-strip mockup__header-strip--small"></div>
              <div class="mockup__body">
                <div class="mockup__block mockup__block--full"></div>
                <div class="mockup__block mockup__block--full"></div>
                <div class="mockup__block mockup__block--btn"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="hero__badges">
      @for (badge of badges(); track badge) {
        <span class="hero__badge">{{ badge }}</span>
      }
    </div> -->
  }
</section>
